import React, { Component } from 'react'
import './Post.scss'
import Token, { getToken } from '../../Utils/Token'
import { apiUrl } from '../../Shared/config'
import Axios from 'axios'
import Spinner from '../../Components/Spinner'
import { calculateTimeDifference } from '../../Utils/Datetime'
import EquationControl from '../../Components/EquationControl'
import PostComment from './PostComment'
import Topbar from '../../Common/Topbar'
import RoundCard from '../../Components/RoundCard'

export default class Post extends Component {

    constructor(props) {
        super(props)

        this.state = {
            post: null,
            error: false,
            liked: false,
            likeLoading: false,
            plus: 'blue',
            showPostReply: false,
            postReply: {
                comment: ''
            },
            postFetching: true,
            postFetched: false,
            addCommentToPostLoading: false,
        }
    }

    componentDidMount() {
        this.getPost()
    }

    getPost = () => {
        this.setState({
            postFetching: true
        })

        let obj = {
            userId: Token.getValue("_id"),
            postId: this.props.match.params.id
        }

        let state = this.state;
        try {
            state.post.comments = [];
            this.setState(state)
        } catch (err) { }

        const url = `${apiUrl}/Post/getpostbyid`
        Axios.post(url, obj).then(res => {
            if (!res.data.error) {
                this.setState({
                    liked: res.data.data.liked,
                    post: res.data.data.post,
                    postFetched: true,
                    postFetching: false
                })
            } else {
                this.setState({
                    error: res.data.error,
                    liked: false,
                    post: {},
                    postFetching: false,
                    postFetched: false
                })
            }
        }).catch(err => {
            this.setState({
                error: JSON.stringify(JSON.parse(err)),
                liked: false,
                post: {},
                postFetching: false,
                postFetched: false
            })
        })
    }

    addRemoveLike = () => {
        this.setState({
            likeLoading: true
        })
        const url = `${apiUrl}/Post/addremovelike`
        let obj = {
            userId: Token.getValue("_id"),
            postId: this.state.post._id
        }
        Axios.post(url, obj).then(res => {
            if (!res.data.error) {
                this.setState({
                    liked: res.data.data.liked,
                    post: res.data.data.post,
                    likeLoading: false
                })
            } else {
                this.setState({
                    liked: this.state.liked,
                    post: this.state.post,
                    likeLoading: false
                })
            }
        }).catch(err => {
            this.setState({
                liked: this.state.liked,
                post: this.state.post,
                likeLoading: false
            })
        })
    }

    showPostReply = () => {
        this.setState({
            showPostReply: !this.state.showPostReply
        })
    }

    onChangePostReply = (e) => {
        this.setState({
            postReply: {
                comment: e.target.value
            }
        })
    }

    addCommentToPost = () => {
        this.setState({
            addCommentToPostLoading: true
        })
        const url = `${apiUrl}/Post/addcommenttopost`
        let obj = {
            userId: Token.getValue("_id"),
            postId: this.state.post._id,
            comment: this.state.postReply
        }

        Axios.post(url, obj).then(res => {
            if (!res.data.error) {
                this.setState({
                    post: res.data.data,
                    postReply: {
                        comment: ''
                    },
                    showPostReply: false,
                    addCommentToPostLoading: false
                })
            } else {
                alert(res.data.error)
                this.setState({
                    addCommentToPostLoading: false
                })
            }
        }).catch(err => {
            alert(JSON.stringify(JSON.parse(err)))
            this.setState({
                addCommentToPostLoading: false
            })
        })
    }

    deletePost = () => {
        const url = `${apiUrl}/Post/deletepost/${this.state.post._id}`
        Axios.get(url).then(res => {
            if (!res.data.error) {
                this.props.history.push('/discussion')
            }
        }).catch(err => {
            console.log(err)
        })
    }

    render() {
        const {
            post, postFetched, postFetching,
            likeLoading,
            addCommentToPostLoading,
        } = this.state
        const posterId = post ? post.posterInfo._id : null;
        const userId = Token.getValue("_id");
        let showDelete = false;
        if (posterId && userId) {
            if (posterId === userId) {
                showDelete = true
            }
        }

        return (
            [
                <Topbar type={'fixedover'} theme={'solid'} />,
                <div className='post-container'>
                    <div className='container'>
                        {
                            postFetching ? (
                                <Spinner />
                            ) : (
                                    postFetched ? (

                                        <RoundCard className={'post-card-main'} scaleOnHover={false}>
                                            <div className='post-main'>
                                                <div className='title'>{post.title || ''}</div>
                                                <div className='poster-info'>
                                                    <div className='name'>{`by ${post.posterInfo.firstName} ${post.posterInfo.lastName}`}</div>
                                                    <div className='time'>{calculateTimeDifference(post.postDate)}</div>
                                                </div>
                                                <div className='description'>
                                                    {
                                                        post.descriptionElements.map((item, idx) => {
                                                            switch (item.type.toLowerCase()) {
                                                                case 'text':
                                                                    return (
                                                                        <div id={item.name}>
                                                                            {item.value}
                                                                        </div>
                                                                    )
                                                                case 'equation':
                                                                    return <EquationControl readOnly={true} item={item} />
                                                                default: return null
                                                            }
                                                        })
                                                    }
                                                </div>
                                                <div className='post-meta'>
                                                    {
                                                        !likeLoading ? (
                                                            <div onClick={getToken() ? this.addRemoveLike : () => { }} className='meta-item'>
                                                                {
                                                                    this.state.liked ? (
                                                                        <img alt='like' src={require('../../Shared/icons/red-heart.svg')} />
                                                                    ) : (
                                                                            <img alt='like' src={require('../../Shared/icons/blank-heart.svg')} />
                                                                        )
                                                                }
                                                                <div className='like-count'>{post.likeCount} {post.likeCount > 1 ? 'likes' : 'like'}</div>
                                                            </div>
                                                        ) : (
                                                                <div className='meta-item'>
                                                                    <img alt='like' src={require('../../Shared/icons/dead-heart.svg')} />
                                                                    <div className='like-count'>Please wait</div>
                                                                </div>
                                                            )
                                                    }
                                                    {
                                                        getToken() ? (
                                                            <div onClick={this.showPostReply} className='meta-item'>
                                                                <img alt='reply' src={'https://image.flaticon.com/icons/svg/893/893266.svg'} />
                                                                <div className='like-count'>Reply</div>
                                                            </div>
                                                        ) : (
                                                                null
                                                            )
                                                    }
                                                    {
                                                        showDelete ? (
                                                            <div onClick={this.deletePost} className='meta-item'>
                                                                <img alt='delete' src={'https://image.flaticon.com/icons/svg/1828/1828843.svg'} />
                                                                <div className='like-count'>Delete</div>
                                                            </div>
                                                        ) : (null)
                                                    }
                                                </div>
                                            </div>

                                            <div className={`reply-on-post ${this.state.showPostReply ? '' : 'zero-height'}`}>
                                                <textarea onChange={this.onChangePostReply} value={this.state.postReply['comment'] || ''} id='comment'></textarea>
                                                {
                                                    !addCommentToPostLoading ? (
                                                        <button onClick={this.addCommentToPost} className='btn-new btn-success'>Save</button>
                                                    ) : (
                                                            <button className='btn-new btn-success'>Please wait</button>
                                                        )
                                                }
                                            </div>

                                            <div className='comments-main'>
                                                <div className='comment-divider'>
                                                    <div className='comment-count'>{post.commentCount} Comments</div>
                                                </div>
                                                {
                                                    post.comments.map((el, idx) => {
                                                        return (
                                                            <PostComment key={idx} data={el} getPost={this.getPost} />
                                                        )
                                                    })
                                                }
                                            </div>
                                        </RoundCard>

                                        // <div className="card-f">

                                        // </div>

                                    ) : null
                                )
                        }
                    </div>
                </div>
            ]
        )
    }
}
